import { render, staticRenderFns } from "./scrollBox.vue?vue&type=template&id=a9b4ed08&scoped=true&"
import script from "./scrollBox.vue?vue&type=script&lang=js&"
export * from "./scrollBox.vue?vue&type=script&lang=js&"
import style0 from "./scrollBox.vue?vue&type=style&index=0&id=a9b4ed08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b4ed08",
  null
  
)

export default component.exports